import React from 'react';
import {
  LoadingButton as MuiLoadingButton,
  LoadingButtonProps,
} from '@mui/lab';

export { LoadingButtonProps };
export default function LoadingButton(props: LoadingButtonProps) {
  let { sx, variant, ...others } = props;
  sx = sx || {};
  variant = variant || 'contained';
  let color = undefined;
  if (variant === 'contained') {
    color = '#fff';
  }

  sx = {
    // color: '#fff',
    borderRadius: '20px',
    padding: '10px 30px',
    color,
    ...sx,
  };

  return <MuiLoadingButton sx={sx} variant={variant} {...others} />;
}
